<div class="form-web-post-data" [formGroup]="formSite">
  <div class="form-header">
    <button
      type="button"
      class="btn btn-primary btn-transparent"
      (click)="addItem()"
      [disabled]="itemsArray.length >= 10"
      >
      <i class="fas fa-plus"></i> {{ "NEW_INJECTS.ADD_POST" | translate }}
    </button>
  </div>

  @if (itemsArray.length > 0) {
    <div class="items-container">
      @for (item of itemsArray.controls; track item; let i = $index) {
        <div
          class="item-card"
          [formGroup]="item"
          >
          <div class="item-header">
            <h5>{{ "NEW_INJECTS.POST" | translate }} {{ i + 1 }}</h5>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              (click)="removeItem(i)"
              [disabled]="itemsArray.length <= 1"
              >
              <i class="fas fa-trash"></i>
            </button>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label [for]="'date_time_' + i">{{
                "ADMIN.COMPANY.PEOPLE.STATUS" | translate
              }}</label>
              <mat-form-field class="select-field select-language">
                <mat-select formControlName="status">
                  <mat-option value="published">{{
                    "NEW_INJECTS.PUBLISHED" | translate
                  }}</mat-option>
                  <mat-option value="in progress" selected>{{
                    "NEW_INJECTS.IN_PROGRESS" | translate
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-group col-md-6">
              <label [for]="'date_time_' + i">{{
                "NEW_INJECTS.PRICE" | translate
              }}</label>
              <mat-form-field class="full-width">
                <input
                  matInput="matInput"
                  formControlName="price"
                  autocomplete="off"
                  [id]="'date_time_' + i"
                  type="number"
                  />
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label [for]="'time_' + i">{{
                "NEW_INJECTS.TIME" | translate
              }}</label>
              <mat-form-field class="full-width">
                <input
                  matInput="matInput"
                  formControlName="time"
                  autocomplete="off"
                  [id]="'time_' + i"
                  />
              </mat-form-field>
            </div>
          </div>
          <div class="languages-section">
            <label [for]="'title_' + i">Title</label>
            <div class="language-inputs" formGroupName="title">
              @for (lang of languages; track lang) {
                <div class="form-group">
                  @if (item.get('title')?.contains(lang)) {
                    <div
                      class="mat-form-field-wrapper"
                      >
                      <mat-form-field class="full-width">
                        <input
                          matInput="matInput"
                          [formControlName]="lang"
                          [placeholder]="lang"
                          autocomplete="off"
                          [id]="'title_' + i"
                          />
                      </mat-form-field>
                    </div>
                  }
                </div>
              }
            </div>
            <span class="label">{{
              "ADMIN.SESSION.SCENARIO_ITEM.CONTENT" | translate
            }}</span>
            <div class="language-inputs" formGroupName="content">
              @for (lang of languages; track lang) {
                <div class="form-group">
                  @if (item.get('content')?.contains(lang)) {
                    <div>
                      <mat-form-field class="full-width">
                        <textarea
                          matInput="matInput"
                          class="form-control"
                          rows="3"
                          [id]="'text_' + lang + '_' + i"
                          [formControlName]="lang"
                          [placeholder]="lang"
                        ></textarea>
                      </mat-form-field>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (itemsArray.length === 0) {
    <div class="no-items">
      <p class="text-muted">No items added yet. Click "Add Item" to start.</p>
    </div>
  }
</div>
